var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5V6",
    stroke: "#D9B373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.999 14C9.861 14 9.749 14.112 9.75 14.25C9.75 14.388 9.862 14.5 10 14.5C10.138 14.5 10.25 14.388 10.25 14.25C10.25 14.112 10.138 14 9.999 14",
    stroke: "#D9B373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12.8805V8.1185C1 6.5165 1.852 5.0355 3.236 4.2295L7.736 1.6105C9.135 0.7965 10.864 0.7965 12.263 1.6105L16.763 4.2295C18.148 5.0355 19 6.5165 19 8.1185V12.8805C19 14.4825 18.148 15.9635 16.764 16.7695L12.264 19.3885C10.865 20.2025 9.136 20.2025 7.737 19.3885L3.237 16.7695C1.852 15.9635 1 14.4825 1 12.8805Z",
    stroke: "#D9B373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.38e8909f09cb3cbf493efbf9b1b505f3.svg";
export { ForwardRef as ReactComponent };